import React from 'react';

const StatusIndicator = ({ color, count }) => (
  <div className="flex flex-1 gap-1">
    <div className={`flex shrink-0 my-auto w-2 h-2 ${color} rounded-full`} />
    <div className="text-xs">{count}</div>
  </div>
);

export default StatusIndicator;